import { Box, Container, Grid, Typography, Chip } from "@mui/material";
import {
  EmojiEventsRounded,
  TrackChangesRounded,
  BoltRounded,
  DiamondRounded,
  AvTimerRounded,
  MilitaryTechRounded,
  SentimentVerySatisfiedRounded,
  CallRounded,
  CheckCircleRounded,
  CalendarMonthRounded,
} from "@mui/icons-material";
import SummaryStat from "./SummaryStat";
import MetricCard from "./MetricCard";
import TeamLeaderboard from "./TeamLeaderboard";
import VibeCheck from "./VibeCheck";
import DailyMissionCard from "./Dailymission";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";
 


const colors = {
  // bg: "#0b0b0f",
  bg : colorTheme('palette', 'night').value,
  // surface: "#0f1014",
  surface :colorTheme('palette', 'night').value,
  // border: "#1f1f23",
  border : colorTheme('palette', 'night').value,
  text: "#e5e7eb",
  // subtext: "#9aa0a6",
  subtext: colorTheme('palette', 'secondary').value,
  // accent: "#a78bfa",
  accent : colorTheme('palette', 'primary').value,
  // gold: "#fbbf24",
  gold :colorTheme('palette', 'neutral').value,
  // green: "#10b981",
  green :  colorTheme('palette', 'positive').value,
  // warningBorder: "rgba(251,191,36,0.35)",
  warningBorder: colorTheme('palette', 'negative').value
};

export default function Overview({ agentKpisData, agentProfileData }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {/* Top summary row */}
      {/* <Grid container spacing={2} sx={{}}>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryStat
            icon={
              <EmojiEventsRounded sx={{ color: "#7C3AED", fontSize: 28 }} />
            }
            label="Team Rank"
            value="Top 3%"
            color="#7C3AED"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryStat
            icon={
              <TrackChangesRounded sx={{ color: "#10B981", fontSize: 28 }} />
            }
            label="Daily Target"
            value="127"
            color="#10B981"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryStat
            icon={<BoltRounded sx={{ color: "#f59e0b", fontSize: 28 }} />}
            label="CSAT Score"
            value="4.8/5"
            color="#f59e0b"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryStat
            icon={<DiamondRounded sx={{ color: "#60a5fa", fontSize: 28 }} />}
            label="XP Points"
            value="1,250"
            color="#60a5fa"
          />
        </Grid>
      </Grid> */}

      {/* KPI cards */}
      <Grid container spacing={2}>
        {/* Section header */}
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              variant={"h2"}
              sx={{
                fontSize: "1.25rem",
                fontWeight: 700,
                // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
                background :colorTheme('palette', 'primary').value,
                lineHeight: "1.75rem",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Performance Metrics
            </Typography>
            <Chip
              size="small"
              label="Live"
              sx={{
                height: 22,
                bgcolor: "rgba(167, 150, 217, 0.2)",
                // color: " #6366F1",
                color : colorTheme('palette', 'primary').value,
                // border: `1px solid #6366F1`,
                fontWeight: 700,
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MetricCard
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-clock w-4 h-4 text-primary"
                data-lov-id="src/components/dashboard/KPICard.tsx:80:14"
                data-lov-name="Icon"
                data-component-path="src/components/dashboard/KPICard.tsx"
                data-component-line="80"
                data-component-file="KPICard.tsx"
                data-component-name="Icon"
                data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-primary%22%7D"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            }
            tier="🥇Gold"
            change="+12%"
            title="Average Handle Time"
            value={agentProfileData?.agentProfileMatrics?.averageHandledTime}
            targetText=""
            leftHint={
              agentProfileData?.agentProfileMatrics?.ahtAchievementPercentage
            }
            rightHint={"Crushing it!"}
            progress={
              agentProfileData?.agentProfileMatrics?.ahtAchievementPercentage ||
              0
            }
            // subTextColor="#F8C630"
            subTextColor={colorTheme('palette', 'neutral').value}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MetricCard
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-star w-4 h-4 text-primary"
                data-lov-id="src/components/dashboard/KPICard.tsx:80:14"
                data-lov-name="Icon"
                data-component-path="src/components/dashboard/KPICard.tsx"
                data-component-line="80"
                data-component-file="KPICard.tsx"
                data-component-name="Icon"
                data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-primary%22%7D"
              >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
              </svg>
            }
            tier="🏆Platinum"
            change="+8%"
            title="Performance Score"
            value={
              agentProfileData?.agentProfileMatrics
                ?.agentOverallPerformancescore
                ? `${agentProfileData?.agentProfileMatrics?.agentOverallPerformancescore}%`
                : "0"
            }
            targetText=""
            leftHint={
              agentProfileData?.agentProfileMatrics
                ?.agentOverallPerformancescore
            }
            rightHint="Crushing it!"
            progress={
              agentProfileData?.agentProfileMatrics
                ?.agentOverallPerformancescore
            }
            // subTextColor="#6366F1"
            subTextColor={colorTheme('palette', 'primary').value}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MetricCard
            // icon={<SentimentVerySatisfiedRounded sx={{ fontSize: 18 }} />}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-users w-4 h-4 text-primary"
                data-lov-id="src/components/dashboard/KPICard.tsx:80:14"
                data-lov-name="Icon"
                data-component-path="src/components/dashboard/KPICard.tsx"
                data-component-line="80"
                data-component-file="KPICard.tsx"
                data-component-name="Icon"
                data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-primary%22%7D"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            }
            tier="💎Diamond"
            change="+0.3"
            title="CSAT Score"
            value={
              agentProfileData?.agentProfileMatrics?.avgAgentCsatScore
                ? `${agentProfileData?.agentProfileMatrics?.avgAgentCsatScore}%`
                : "0"
            }
            targetText=""
            leftHint={agentProfileData?.agentProfileMatrics?.avgAgentCsatScore}
            rightHint="Crushing it!"
            progress={agentProfileData?.agentProfileMatrics?.avgAgentCsatScore}
            // subTextColor="#00BEFE"
            subTextColor={colorTheme('palette', 'agent').value}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MetricCard
            // icon={<CallRounded sx={{ fontSize: 18 }} />}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-phone w-4 h-4 text-primary"
                data-lov-id="src/components/dashboard/KPICard.tsx:80:14"
                data-lov-name="Icon"
                data-component-path="src/components/dashboard/KPICard.tsx"
                data-component-line="80"
                data-component-file="KPICard.tsx"
                data-component-name="Icon"
                data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-primary%22%7D"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            }
            tier="💎Diamond"
            change="+27%"
            title="Call Volume"
            value={
              agentProfileData?.agentProfileMatrics?.totalProcessedCallVolume
            }
            targetText={`processed/${agentProfileData?.agentProfileMatrics?.totalCallVolume}`}
            leftHint={
              agentProfileData?.agentProfileMatrics?.totalProcessedCallVolume
            }
            rightHint="Crushing it!"
            progress={95}
            borderAccent={colors.warningBorder}
            // subTextColor="#00BEFE"
            subTextColor={colorTheme('palette', 'agent').value}
          />
        </Grid>

        {/* <Grid item xs={12} sm={6} md={4} lg={2}>
          <MetricCard
            // icon={<CheckCircleRounded sx={{ fontSize: 18 }} />}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-circle-check-big w-4 h-4 text-primary"
                data-lov-id="src/components/dashboard/KPICard.tsx:80:14"
                data-lov-name="Icon"
                data-component-path="src/components/dashboard/KPICard.tsx"
                data-component-line="80"
                data-component-file="KPICard.tsx"
                data-component-name="Icon"
                data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-primary%22%7D"
              >
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
            }
            tier="🥇Gold"
            change="+4%"
            title="First Call Resolution"
            value="89%"
            targetText="/85%"
            leftHint="89%"
            rightHint="On track"
            progress={89}
            subTextColor="#F8C630"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <MetricCard
            // icon={<CalendarMonthRounded sx={{ fontSize: 18 }} />}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-calendar w-4 h-4 text-primary"
                data-lov-id="src/components/dashboard/KPICard.tsx:80:14"
                data-lov-name="Icon"
                data-component-path="src/components/dashboard/KPICard.tsx"
                data-component-line="80"
                data-component-file="KPICard.tsx"
                data-component-name="Icon"
                data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-primary%22%7D"
              >
                <path d="M8 2v4"></path>
                <path d="M16 2v4"></path>
                <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                <path d="M3 10h18"></path>
              </svg>
            }
            tier="💎Diamond"
            change="-1%"
            title="Schedule Adherence"
            value="96%"
            targetText="/95%"
            leftHint="96%"
            rightHint="Crushing it!"
            progress={96}
            subTextColor="#00BEFE"
          />
        </Grid> */}
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} lg={12}>
          <TeamLeaderboard
            agentKpisData={agentKpisData}
            agentProfileData={agentProfileData}
          />
        </Grid>

        {/* <Grid item xs={12} sm={6} lg={6}>
          <VibeCheck agentKpisData={agentKpisData} />
        </Grid> */}

        {/* <Grid item xs={12} lg={12}>
          <DailyMissionCard />
         
        </Grid> */}
      </Grid>
    </Box>
  );
}
